import React from 'react';
import Helmet from 'react-helmet';
import Profile from 'containers/Account/views/Profile';
import { IS_ARABIC } from '../../constants';
import { translate } from '../../constants/language';

export default () => {
  return (
    <>
      <Helmet>
        <html lang={IS_ARABIC ? 'ar' : 'en'} dir={IS_ARABIC ? 'rtl' : 'ltr'} />
        <title>
          {translate('Styli')} - {translate('Online fashion store')}
        </title>
      </Helmet>
      <Profile />
    </>
  );
};
